import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { dutiesAndTaxesMessages } from '../../../fulfillment-planner/duties-and-taxes/messages';
import { emptyObject } from 'ui-components/default-props/empty';
import { FormattedCurrencyContainer } from '../../../components/formatted-currency/container';
import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { Recipient, SenderPrepay } from '../../../fulfillment-planner/duties-and-taxes/constants';
import { usePrepaidDutyAndPrice } from '../../../fulfillment-planner/hooks/use-prepaid-duty-and-price';

import style from './style.module.css';

const dutiesAndTaxesOptions = {
  [Recipient]: 'recipientPaysOption',
  [SenderPrepay]: 'prepayDutiesOption',
};

const DutiesAndTaxes = ({ availableShippingOptions, options }) => {
  const { prepaidDuty = '', price = emptyObject } = usePrepaidDutyAndPrice({ availableShippingOptions, options }) || {};

  const ddpPrice = prepaidDuty === SenderPrepay ? <FormattedCurrencyContainer currencyCode={price?.code} value={price?.value} /> : null;

  return (
    prepaidDuty && (
      <LabeledRow className={style.row} label={<FormattedMessage {...dutiesAndTaxesMessages.label} />} labelClassName={style.label}>
        <FormattedMessage {...dutiesAndTaxesMessages[dutiesAndTaxesOptions[prepaidDuty]]} values={{ ddpPrice }} />
      </LabeledRow>
    )
  );
};

DutiesAndTaxes.propTypes = {
  availableShippingOptions: PropTypes.array.isRequired,
  options: PropTypes.shape({
    additionalOptions: PropTypes.array,
  }).isRequired,
};

export default DutiesAndTaxes;
